//CONDITIONAL FORMATTING

import { OptionsValues } from '@smartera/core';

export const ConditionalFormattingMethodOptions: OptionsValues = [
	{ label: 'methods-list.empty', value: 'empty' },
	{ label: 'methods-list.less-than', value: 'less-than' },
	{ label: 'methods-list.less-than-equal', value: 'less-than-equal' },
	{ label: 'methods-list.equal', value: 'equal' },
	{ label: 'methods-list.greater-than', value: 'greater-than' },
	{ label: 'methods-list.greater-than-equal', value: 'greater-than-equal' },
];

export const ConditionalFormattingFontStyleOptions: OptionsValues = [
	{ label: 'Arial', value: 'Arial' },
	{ label: 'Helvetica', value: 'Helvetica' },
	{ label: 'Poppins', value: 'Poppins' },
	{ label: 'Times New Roman', value: 'Times New Roman' },
	{ label: 'Sans-serif', value: 'sans-serif' },
	{ label: 'Monospace', value: 'monospace' },
	{ label: 'Cursive', value: 'cursive' },
];

export const ConditionalFormattingFontSizeOptions: OptionsValues = [
	{ label: '8px', value: '8px' },
	{ label: '9px', value: '9px' },
	{ label: '10px', value: '10px' },
	{ label: '11px', value: '11px' },
	{ label: '12px', value: '12px' },
	{ label: '13px', value: '13px' },
	{ label: '14px', value: '14px' },
	{ label: '15px', value: '15px' },
	{ label: '16px', value: '16px' },
	{ label: '17px', value: '17px' },
	{ label: '18px', value: '18px' },
	{ label: '19px', value: '19px' },
];
